<!-- top bar -- menú -->
<app-top-bar></app-top-bar>
<!-- Contenido -->    
<div class="container-fluid">
    <router-outlet></router-outlet>
</div>
